// Sistema de traducción para HelpDesk TI — FUNIBER
// Añadir nuevos idiomas aquí

const translations = {

  // ── Español (default) ──────────────────────────────────
  es: {
    // Navegación
    'nav.dashboard':     'Dashboard',
    'nav.tickets':       'Tickets',
    'nav.calendar':      'Calendario',
    'nav.computers':     'Equipos',
    'nav.agents':        'Agentes',
    'nav.sla':           'SLA',
    'nav.surveys':       'Encuestas',
    'nav.clients':       'Clientes',
    'nav.departments':   'Derivaciones',
    'nav.extensions':    'Extensiones',
    'nav.rooms':         'Reservas',
    'nav.reports':       'Informes',
    'nav.superadmin':    'SuperAdmin',

    // AppBar
    'app.logout':        'Cerrar sesión',
    'app.profile':       'Mi perfil',
    'app.whats_new':     'Novedades',
    'app.notifications': 'Notificaciones',

    // Dashboard
    'dashboard.my_tickets':      'Mis tickets activos',
    'dashboard.unassigned':      'Sin asignar',
    'dashboard.escalated':       'Escalados',
    'dashboard.critical_active': 'Críticos activos',
    'dashboard.resolved_today':  'Resueltos hoy',
    'dashboard.my_assigned':     'Mis tickets asignados',
    'dashboard.team_queue':      'Cola del equipo',
    'dashboard.no_assigned':     'No tienes tickets asignados actualmente 🎉',
    'dashboard.new_ticket':      '+ Nuevo ticket',
    'dashboard.search':          'Buscar por título, ref o usuario...',

    // Tickets
    'ticket.new':           'Nuevo ticket',
    'ticket.ref':           'Referencia',
    'ticket.title':         'Título',
    'ticket.status':        'Estado',
    'ticket.priority':      'Prioridad',
    'ticket.agent':         'Agente',
    'ticket.client':        'Solicitante',
    'ticket.created':       'Creado',
    'ticket.updated':       'Actualizado',
    'ticket.all':           'Todas',
    'ticket.critical':      'Crítica',
    'ticket.high':          'Alta',
    'ticket.medium':        'Media',
    'ticket.low':           'Baja',
    'ticket.open':          'Abierto',
    'ticket.in_progress':   'En progreso',
    'ticket.resolved':      'Resuelto',
    'ticket.closed':        'Cerrado',
    'ticket.pending':       'Pendiente',
    'ticket.assign_me':     'Asignarme',
    'ticket.escalate':      'Escalar',
    'ticket.resolve':       'Resolver',
    'ticket.close':         'Cerrar',
    'ticket.reopen':        'Reabrir',
    'ticket.add_comment':   'Añadir comentario',
    'ticket.internal_note': 'Nota interna',
    'ticket.description':   'Descripción',
    'ticket.attachments':   'Adjuntos',
    'ticket.history':       'Historial',
    'ticket.save':          'Guardar',
    'ticket.cancel':        'Cancelar',
    'ticket.send':          'Enviar',
    'ticket.category':      'Categoría',
    'ticket.department':    'Departamento',
    'ticket.level':         'Nivel',
    'ticket.sla':           'SLA',

    // Estados
    'status.open':        'Abierto',
    'status.in_progress': 'En progreso',
    'status.pending':     'Pendiente',
    'status.resolved':    'Resuelto',
    'status.closed':      'Cerrado',

    // Prioridades
    'priority.critical': 'Crítica',
    'priority.high':     'Alta',
    'priority.medium':   'Media',
    'priority.low':      'Baja',

    // Agentes
    'agents.title':      'Agentes',
    'agents.new':        'Nuevo agente',
    'agents.name':       'Nombre',
    'agents.email':      'Email',
    'agents.role':       'Rol',
    'agents.level':      'Nivel',
    'agents.status':     'Estado',
    'agents.active':     'Activo',
    'agents.inactive':   'Inactivo',
    'agents.online':     'En línea',
    'agents.offline':    'Desconectado',
    'agents.admin':      'Administrador',
    'agents.agent':      'Agente',
    'agents.superadmin': 'SuperAdmin',

    // Reservas
    'rooms.title':       'Gestión de Reservas',
    'rooms.new':         'Nueva reserva',
    'rooms.rooms':       'Salas',
    'rooms.locations':   'Ubicaciones',
    'rooms.categories':  'Categorías',
    'rooms.bookings':    'Reservas',
    'rooms.reports':     'Informes',
    'rooms.confirmed':   'Confirmada',
    'rooms.pending':     'Pendiente',
    'rooms.rejected':    'Rechazada',
    'rooms.capacity':    'Capacidad',
    'rooms.equipment':   'Equipamiento',

    // Informes
    'reports.title':         'Informes y Facturación',
    'reports.generate':      'Generar informe',
    'reports.export_csv':    'Exportar CSV',
    'reports.save_filters':  'Guardar filtros',
    'reports.filters':       'Filtros',
    'reports.period':        'Período',
    'reports.categories':    'Categorías',
    'reports.rooms':         'Salas',
    'reports.status':        'Estado',
    'reports.group_by':      'Agrupar por',
    'reports.calc_by':       'Calcular duración por',
    'reports.hours':         'Horas',
    'reports.days':          'Días',
    'reports.include_prices':'Incluir importes',
    'reports.all':           'Todas',
    'reports.confirmed':     'Confirmadas',
    'reports.pending':       'Pendientes',
    'reports.bookings_total':'Reservas',
    'reports.hours_total':   'Horas totales',
    'reports.days_total':    'Días totales',
    'reports.amount_total':  'Importe total',
    'reports.detail':        'Detalle de reservas',

    // General
    'general.save':    'Guardar',
    'general.cancel':  'Cancelar',
    'general.delete':  'Eliminar',
    'general.edit':    'Editar',
    'general.create':  'Crear',
    'general.close':   'Cerrar',
    'general.search':  'Buscar',
    'general.filter':  'Filtrar',
    'general.loading': 'Cargando…',
    'general.yes':     'Sí',
    'general.no':      'No',
    'general.confirm': 'Confirmar',
    'general.back':    'Volver',
    'general.next':    'Siguiente',
    'general.today':   'Hoy',
    'general.name':    'Nombre',
    'general.email':   'Email',
    'general.date':    'Fecha',
    'general.actions': 'Acciones',
    'general.results': 'resultados',
    'general.of':      'de',
    'general.and':     'y',
    'general.or':      'o',
    'general.empty':   'Sin resultados',

    // Login
    'login.title':       'Accede con tu cuenta institucional',
    'login.google':      'Iniciar sesión con Google',
    'login.username':    'Usuario',
    'login.password':    'Contraseña',
    'login.submit':      'Entrar',
    'login.error':       'Usuario o contraseña incorrectos',
    'login.error_domain':'Solo cuentas institucionales',


    // TicketList / TicketDetail
    'ticket.list_title':     'Tickets',
    'ticket.all_tickets':    'Todos los tickets',
    'ticket.my_tickets':     'Mis tickets',
    'ticket.unassigned':     'Sin asignar',
    'ticket.new_btn':        '+ Nuevo ticket',
    'ticket.search':         'Buscar tickets...',
    'ticket.filter_status':  'Estado',
    'ticket.filter_prio':    'Prioridad',
    'ticket.assignee':       'Asignado a',
    'ticket.requester':      'Solicitante',
    'ticket.no_agent':       'Sin agente',
    'ticket.take':           'Tomar',
    'ticket.assign':         'Asignar',
    'ticket.comment_public': 'Comentario público',
    'ticket.comment_add':    'Añadir comentario',
    'ticket.note_internal':  'Nota interna',
    'ticket.reply':          'Responder',
    'ticket.forward':        'Derivar',
    'ticket.escalate_btn':   'Escalar',
    'ticket.mark_resolved':  'Marcar como resuelto',
    'ticket.reopen_btn':     'Reabrir',
    'ticket.close_btn':      'Cerrar ticket',
    'ticket.survey':         'Encuesta',
    'ticket.attachments_add':'Adjuntar archivo',
    'ticket.no_comments':    'Sin comentarios todavía',
    'ticket.no_results':     'No se encontraron tickets',
    'ticket.loading':        'Cargando tickets…',
    'ticket.details':        'Detalles del ticket',
    'ticket.timeline':       'Historial',
    'ticket.info':           'Información',

    // Agentes
    'agents.search':         'Buscar agentes...',
    'agents.departments':    'Departamentos',
    'agents.dept_new':       'Nuevo departamento',
    'agents.no_results':     'No se encontraron agentes',
    'agents.confirm_delete': '¿Eliminar este agente?',
    'agents.max_level':      'Nivel máximo',
    'agents.password':       'Contraseña',
    'agents.confirm_pass':   'Confirmar contraseña',
    'agents.save':           'Guardar agente',

    // SLA
    'sla.title':             'Configuración SLA',
    'sla.new':               'Nueva regla SLA',
    'sla.name':              'Nombre',
    'sla.response_time':     'Tiempo de respuesta',
    'sla.resolve_time':      'Tiempo de resolución',
    'sla.hours':             'horas',
    'sla.active':            'Activa',

    // Encuestas
    'surveys.title':         'Encuestas de satisfacción',
    'surveys.rating':        'Valoración',
    'surveys.comment':       'Comentario',
    'surveys.date':          'Fecha',
    'surveys.ticket':        'Ticket',

    // Clientes
    'clients.title':         'Clientes VIP',
    'clients.new':           'Nuevo cliente',
    'clients.company':       'Empresa',
    'clients.contact':       'Contacto',
    'clients.tickets':       'Tickets',

    // Derivaciones
    'depts.title':           'Derivaciones',
    'depts.new':             'Nuevo departamento',
    'depts.email':           'Email de destino',
    'depts.forward':         'Derivar a',

    // Equipos
    'computers.title':       'Inventario de equipos',
    'computers.hostname':    'Nombre del equipo',
    'computers.ip':          'IP',
    'computers.os':          'Sistema operativo',
    'computers.last_seen':   'Última conexión',
    'computers.online':      'En línea',
    'computers.offline':     'Desconectado',

    // Calendario
    'calendar.title':        'Calendario',
    'calendar.new_event':    'Nuevo evento',
    'calendar.today':        'Hoy',
    'calendar.week':         'Semana',
    'calendar.month':        'Mes',


    // TicketDetail extra
    'ticket.schedule':       'Agendar',
    'ticket.forward_btn':    'Derivar',
    'ticket.change_level':   'Cambiar nivel',
    'ticket.resolve_btn':    'Resolver',
    'ticket.public':         'Público',
    'ticket.internal':       'Interno',
    'ticket.public_note':    '🌐 Público — el usuario verá esto',
    'ticket.internal_note2': '🔒 Interno — solo el equipo TI',
    'ticket.public_comment': '🌐 Comentario público — el usuario recibirá un email',
    'ticket.internal_comment':'🔒 Nota interna — no visible para el usuario',
    'ticket.assign_this':    'Asignarme este ticket',
    'ticket.assignment':     'Asignación',
    'ticket.comments_tab':   'Comentarios',
    'ticket.device_tab':     'Equipo',
    'ticket.history_tab':    'Historial',
    'ticket.not_found':      'Ticket no encontrado',
    'ticket.add_files':      'Archivos adjuntos',
    'ticket.event_desc':     'Descripción',
    'ticket.schedule_title': 'Agendar evento',
    'ticket.forward_title':  'Derivar ticket',
    'ticket.level_title':    'Cambiar nivel',
    'ticket.info_card':      'Información',
    'ticket.sla_card':       'SLA',
    'ticket.sla_ok':         'Resuelto dentro del SLA',
    'ticket.sla_over':       '⚠ SLA superado',
    'ticket.write_comment':  'Escribe una actualización para el usuario...',
    'ticket.write_internal': 'Escribe una nota interna...',


    // TicketDetail fields
    'ticket.agent_assigned':  'Agente asignado',
    'ticket.reference':       'Referencia',
    'ticket.created_at':      'Creado',
    'ticket.resolve_time':    'Tiempo de resolución',
    'ticket.extra_info':      'Información adicional',
    'ticket.email':           'Email',
    'ticket.escalated_to':    'Escalado a nivel N',


    // FrontDesk formulario
    'fd.hero_title':       '¿Cómo podemos',
    'fd.hero_accent':      'ayudarte hoy?',
    'fd.hero_desc':        'Describe tu problema. Nuestro sistema lo analizará automáticamente con IA.',
    'fd.have_ticket':      '¿Ya tienes un ticket?',
    'fd.consult':          'Consultar',
    'fd.more_info':        'Más información',
    'fd.response_times':   'Tiempos de respuesta por prioridad',
    'fd.device_data':      'Datos del equipo',
    'fd.new_ticket_title': 'Nuevo ticket de soporte',
    'fd.your_data':        'Tus datos',
    'fd.full_name':        'Nombre completo',
    'fd.contact_email':    'Email de contacto',
    'fd.the_problem':      'El problema',
    'fd.title_field':      'Título',
    'fd.impact':           'Indica el impacto en tu trabajo',
    'fd.extra_info':       'Información adicional',
    'fd.problem_type':     'Tipo de problema',
    'fd.describe':         'Describe el problema, mensajes de error, desde cuándo ocurre…',
    'fd.attach':           'Adjuntar archivo · arrastra aquí · PNG, JPG, PDF, Word',
    'fd.clear':            'Limpiar',
    'fd.send':             'Enviar',
    'fd.required':         'Nombre y título son obligatorios.',
    'fd.estimate':         'Estimación beta · puede variar',
    'fd.impact1_label':    'No puedo trabajar en absoluto',
    'fd.impact1_desc':     'Equipo caído, sin red, cuenta bloqueada…',
    'fd.impact2_label':    'Trabajo muy limitado',
    'fd.impact2_desc':     'Periférico roto, email con fallos, sin carpetas compartidas…',
    'fd.impact3_label':    'Puedo trabajar con dificultad',
    'fd.impact3_desc':     'WiFi lento, aplicación secundaria con errores…',
    'fd.impact4_label':    'Es una molestia, puede esperar',
    'fd.impact4_desc':     'Instalación, alta de usuario, configuración…',


    'general.language':      'Idioma',
    'general.user_portal':   'Portal de usuario',
    'general.public_dir':    'Directorio público',
    'general.room_booking':  'Reserva de espacios',
    'general.logout':        'Cerrar sesión',


    'ticketlist.title':       'Todos los tickets',
    'ticketlist.search':      'Buscar ref, título, solicitante…',
    'ticketlist.filter_status': 'Estado',
    'ticketlist.filter_prio': 'Prioridad',
    'ticketlist.filter_level':'Nivel',
    'ticketlist.col_ref':     'Ref',
    'ticketlist.col_title':   'Título',
    'ticketlist.col_status':  'Estado',
    'ticketlist.col_prio':    'Prioridad',
    'ticketlist.col_level':   'Nivel',
    'ticketlist.col_agent':   'Agente',
    'ticketlist.col_sla':     'SLA',
    'ticketlist.col_updated': 'Actualizado',
    'ticketlist.unassigned':  'Sin asignar',
    'ticketlist.take':        'Tomar',

    // FrontDesk
    'fd.new_ticket':     'Nuevo ticket',
    'fd.track_ticket':   'Seguir ticket',
    'fd.title':          'Soporte Técnico',
    'fd.subtitle':       'Estamos aquí para ayudarte',
    'fd.ticket_ref':     'Referencia del ticket',
    'fd.search':         'Escribe tu consulta...',
    // TrackTicket
    'track.title':               'Estado del Ticket',
    'track.forwarded_status':    'Cerrado',
    'track.forwarded_desc':      'Tu solicitud ha sido redirigida al departamento correspondiente',
    'track.in_process':          'En proceso',
    'track.prio_low':            'Baja',
    'track.prio_medium':         'Media',
    'track.prio_high':           'Alta',
    'track.prio_critical':       'Crítica',
    'track.agent_assigned':      'Agente asignado',
    'track.support_ti':          'Soporte TI',
    'track.pending_assign':      'Pendiente de asignación',
    'track.pending_assign_desc': 'Un agente revisará tu ticket en breve',
    'track.what_next':           '¿Qué pasa después?',
    'track.step_reception':      'Recepción',
    'track.step_reception_desc': 'La IA ha clasificado tu ticket.',
    'track.step_assign':         'Asignación',
    'track.step_assign_desc':    'Se asigna al agente adecuado.',
    'track.step_resolution':     'Resolución',
    'track.step_resolution_desc':'Te mantienen informado por email.',
    'track.step_close':          'Cierre',
    'track.step_close_desc':     'Confirmamos la solución contigo.',
    'track.info_title':          'Información de seguimiento',
    'track.field_title':         'Título',
    'track.field_requester':     'Solicitante',
    'track.field_email':         'Email',
    'track.field_level':         'Nivel de soporte',
    'track.field_level_val':     'Nivel',
    'track.field_created':       'Creado',
    'track.status_label':        'Estado del ticket',
    'track.step_open':           'Abierto',
    'track.step_open_desc':      'Ticket registrado y clasificado',
    'track.step_progress':       'En progreso',
    'track.step_progress_desc':  'Un agente está trabajando en ello',
    'track.step_escalated':      'Escalado',
    'track.step_escalated_desc': 'Derivado a soporte especializado',
    'track.step_resolved':       'Resuelto',
    'track.step_resolved_desc':  'Problema solucionado',
    'track.description':         'Descripción',
    'track.updates_title':       'Actualizaciones del equipo TI',
    'track.no_updates':          'El equipo de soporte aún no ha añadido actualizaciones. Te notificaremos por email cuando haya novedades.',
    'track.resolved_banner':     'Este ticket ha sido resuelto',
    'track.resolved_banner_sub': 'Si el problema persiste, puedes abrir un nuevo ticket.',
    'track.reply_title':         'Añadir respuesta',
    'track.reply_placeholder':   'Escribe aquí tu respuesta o información adicional para el equipo de soporte…',
    'track.reply_hint':          'Tu respuesta será visible para el equipo TI',
    'track.reply_sending':       'Enviando…',
    'track.reply_send':          'Enviar respuesta',
    'track.reply_done':          '✓ Respuesta enviada',
    'track.back':                'Volver',
    'track.loading':             'Cargando…',
    'track.searching':           'Buscando tu ticket…',
    'track.not_found_title':     'No encontrado',
    'track.open_new':            'Abrir nuevo ticket',
    'track.toast':               'Ticket enviado correctamente — te hemos enviado confirmación por email',
  },

  // ── Português ──────────────────────────────────────────
  pt: {
    // Navegação
    'nav.dashboard':     'Dashboard',
    'nav.tickets':       'Tickets',
    'nav.calendar':      'Calendário',
    'nav.computers':     'Equipamentos',
    'nav.agents':        'Agentes',
    'nav.sla':           'SLA',
    'nav.surveys':       'Inquéritos',
    'nav.clients':       'Clientes',
    'nav.departments':   'Encaminhamentos',
    'nav.extensions':    'Extensões',
    'nav.rooms':         'Reservas',
    'nav.reports':       'Relatórios',
    'nav.superadmin':    'SuperAdmin',

    // AppBar
    'app.logout':        'Terminar sessão',
    'app.profile':       'O meu perfil',
    'app.whats_new':     'Novidades',
    'app.notifications': 'Notificações',

    // Dashboard
    'dashboard.my_tickets':      'Os meus tickets ativos',
    'dashboard.unassigned':      'Por atribuir',
    'dashboard.escalated':       'Escalados',
    'dashboard.critical_active': 'Críticos ativos',
    'dashboard.resolved_today':  'Resolvidos hoje',
    'dashboard.my_assigned':     'Os meus tickets atribuídos',
    'dashboard.team_queue':      'Fila da equipa',
    'dashboard.no_assigned':     'Não tens tickets atribuídos atualmente 🎉',
    'dashboard.new_ticket':      '+ Novo ticket',
    'dashboard.search':          'Pesquisar por título, ref ou utilizador...',

    // Tickets
    'ticket.new':           'Novo ticket',
    'ticket.ref':           'Referência',
    'ticket.title':         'Título',
    'ticket.status':        'Estado',
    'ticket.priority':      'Prioridade',
    'ticket.agent':         'Agente',
    'ticket.client':        'Solicitante',
    'ticket.created':       'Criado',
    'ticket.updated':       'Atualizado',
    'ticket.all':           'Todos',
    'ticket.critical':      'Crítica',
    'ticket.high':          'Alta',
    'ticket.medium':        'Média',
    'ticket.low':           'Baixa',
    'ticket.open':          'Aberto',
    'ticket.in_progress':   'Em progresso',
    'ticket.resolved':      'Resolvido',
    'ticket.closed':        'Fechado',
    'ticket.pending':       'Pendente',
    'ticket.assign_me':     'Atribuir a mim',
    'ticket.escalate':      'Escalar',
    'ticket.resolve':       'Resolver',
    'ticket.close':         'Fechar',
    'ticket.reopen':        'Reabrir',
    'ticket.add_comment':   'Adicionar comentário',
    'ticket.internal_note': 'Nota interna',
    'ticket.description':   'Descrição',
    'ticket.attachments':   'Anexos',
    'ticket.history':       'Histórico',
    'ticket.save':          'Guardar',
    'ticket.cancel':        'Cancelar',
    'ticket.send':          'Enviar',
    'ticket.category':      'Categoria',
    'ticket.department':    'Departamento',
    'ticket.level':         'Nível',
    'ticket.sla':           'SLA',

    // Estados
    'status.open':        'Aberto',
    'status.in_progress': 'Em progresso',
    'status.pending':     'Pendente',
    'status.resolved':    'Resolvido',
    'status.closed':      'Fechado',

    // Prioridades
    'priority.critical': 'Crítica',
    'priority.high':     'Alta',
    'priority.medium':   'Média',
    'priority.low':      'Baixa',

    // Agentes
    'agents.title':      'Agentes',
    'agents.new':        'Novo agente',
    'agents.name':       'Nome',
    'agents.email':      'Email',
    'agents.role':       'Perfil',
    'agents.level':      'Nível',
    'agents.status':     'Estado',
    'agents.active':     'Ativo',
    'agents.inactive':   'Inativo',
    'agents.online':     'Em linha',
    'agents.offline':    'Desligado',
    'agents.admin':      'Administrador',
    'agents.agent':      'Agente',
    'agents.superadmin': 'SuperAdmin',

    // Reservas
    'rooms.title':       'Gestão de Reservas',
    'rooms.new':         'Nova reserva',
    'rooms.rooms':       'Salas',
    'rooms.locations':   'Localizações',
    'rooms.categories':  'Categorias',
    'rooms.bookings':    'Reservas',
    'rooms.reports':     'Relatórios',
    'rooms.confirmed':   'Confirmada',
    'rooms.pending':     'Pendente',
    'rooms.rejected':    'Rejeitada',
    'rooms.capacity':    'Capacidade',
    'rooms.equipment':   'Equipamento',

    // Relatórios
    'reports.title':         'Relatórios e Faturação',
    'reports.generate':      'Gerar relatório',
    'reports.export_csv':    'Exportar CSV',
    'reports.save_filters':  'Guardar filtros',
    'reports.filters':       'Filtros',
    'reports.period':        'Período',
    'reports.categories':    'Categorias',
    'reports.rooms':         'Salas',
    'reports.status':        'Estado',
    'reports.group_by':      'Agrupar por',
    'reports.calc_by':       'Calcular duração por',
    'reports.hours':         'Horas',
    'reports.days':          'Dias',
    'reports.include_prices':'Incluir valores',
    'reports.all':           'Todos',
    'reports.confirmed':     'Confirmadas',
    'reports.pending':       'Pendentes',
    'reports.bookings_total':'Reservas',
    'reports.hours_total':   'Total de horas',
    'reports.days_total':    'Total de dias',
    'reports.amount_total':  'Valor total',
    'reports.detail':        'Detalhe das reservas',

    // Geral
    'general.save':    'Guardar',
    'general.cancel':  'Cancelar',
    'general.delete':  'Eliminar',
    'general.edit':    'Editar',
    'general.create':  'Criar',
    'general.close':   'Fechar',
    'general.search':  'Pesquisar',
    'general.filter':  'Filtrar',
    'general.loading': 'A carregar…',
    'general.yes':     'Sim',
    'general.no':      'Não',
    'general.confirm': 'Confirmar',
    'general.back':    'Voltar',
    'general.next':    'Seguinte',
    'general.today':   'Hoje',
    'general.name':    'Nome',
    'general.email':   'Email',
    'general.date':    'Data',
    'general.actions': 'Ações',
    'general.results': 'resultados',
    'general.of':      'de',
    'general.and':     'e',
    'general.or':      'ou',
    'general.empty':   'Sem resultados',

    // Login
    'login.title':       'Acede com a tua conta institucional',
    'login.google':      'Iniciar sessão com Google',
    'login.username':    'Utilizador',
    'login.password':    'Palavra-passe',
    'login.submit':      'Entrar',
    'login.error':       'Utilizador ou palavra-passe incorretos',
    'login.error_domain':'Apenas contas institucionais',


    // TicketList / TicketDetail
    'ticket.list_title':     'Tickets',
    'ticket.all_tickets':    'Todos os tickets',
    'ticket.my_tickets':     'Os meus tickets',
    'ticket.unassigned':     'Por atribuir',
    'ticket.new_btn':        '+ Novo ticket',
    'ticket.search':         'Pesquisar tickets...',
    'ticket.filter_status':  'Estado',
    'ticket.filter_prio':    'Prioridade',
    'ticket.assignee':       'Atribuído a',
    'ticket.requester':      'Solicitante',
    'ticket.no_agent':       'Sem agente',
    'ticket.take':           'Assumir',
    'ticket.assign':         'Atribuir',
    'ticket.comment_public': 'Comentário público',
    'ticket.comment_add':    'Adicionar comentário',
    'ticket.note_internal':  'Nota interna',
    'ticket.reply':          'Responder',
    'ticket.forward':        'Encaminhar',
    'ticket.escalate_btn':   'Escalar',
    'ticket.mark_resolved':  'Marcar como resolvido',
    'ticket.reopen_btn':     'Reabrir',
    'ticket.close_btn':      'Fechar ticket',
    'ticket.survey':         'Inquérito',
    'ticket.attachments_add':'Anexar ficheiro',
    'ticket.no_comments':    'Sem comentários ainda',
    'ticket.no_results':     'Nenhum ticket encontrado',
    'ticket.loading':        'A carregar tickets…',
    'ticket.details':        'Detalhes do ticket',
    'ticket.timeline':       'Histórico',
    'ticket.info':           'Informação',

    // Agentes
    'agents.search':         'Pesquisar agentes...',
    'agents.departments':    'Departamentos',
    'agents.dept_new':       'Novo departamento',
    'agents.no_results':     'Nenhum agente encontrado',
    'agents.confirm_delete': 'Eliminar este agente?',
    'agents.max_level':      'Nível máximo',
    'agents.password':       'Palavra-passe',
    'agents.confirm_pass':   'Confirmar palavra-passe',
    'agents.save':           'Guardar agente',

    // SLA
    'sla.title':             'Configuração SLA',
    'sla.new':               'Nova regra SLA',
    'sla.name':              'Nome',
    'sla.response_time':     'Tempo de resposta',
    'sla.resolve_time':      'Tempo de resolução',
    'sla.hours':             'horas',
    'sla.active':            'Ativa',

    // Inquéritos
    'surveys.title':         'Inquéritos de satisfação',
    'surveys.rating':        'Avaliação',
    'surveys.comment':       'Comentário',
    'surveys.date':          'Data',
    'surveys.ticket':        'Ticket',

    // Clientes
    'clients.title':         'Clientes VIP',
    'clients.new':           'Novo cliente',
    'clients.company':       'Empresa',
    'clients.contact':       'Contacto',
    'clients.tickets':       'Tickets',

    // Encaminhamentos
    'depts.title':           'Encaminhamentos',
    'depts.new':             'Novo departamento',
    'depts.email':           'Email de destino',
    'depts.forward':         'Encaminhar para',

    // Equipamentos
    'computers.title':       'Inventário de equipamentos',
    'computers.hostname':    'Nome do equipamento',
    'computers.ip':          'IP',
    'computers.os':          'Sistema operativo',
    'computers.last_seen':   'Última ligação',
    'computers.online':      'Em linha',
    'computers.offline':     'Desligado',

    // Calendário
    'calendar.title':        'Calendário',
    'calendar.new_event':    'Novo evento',
    'calendar.today':        'Hoje',
    'calendar.week':         'Semana',
    'calendar.month':        'Mês',


    // TicketDetail extra
    'ticket.schedule':       'Agendar',
    'ticket.forward_btn':    'Encaminhar',
    'ticket.change_level':   'Mudar nível',
    'ticket.resolve_btn':    'Resolver',
    'ticket.public':         'Público',
    'ticket.internal':       'Interno',
    'ticket.public_note':    '🌐 Público — o utilizador verá isto',
    'ticket.internal_note2': '🔒 Interno — apenas a equipa TI',
    'ticket.public_comment': '🌐 Comentário público — o utilizador receberá um email',
    'ticket.internal_comment':'🔒 Nota interna — não visível para o utilizador',
    'ticket.assign_this':    'Atribuir este ticket a mim',
    'ticket.assignment':     'Atribuição',
    'ticket.comments_tab':   'Comentários',
    'ticket.device_tab':     'Equipamento',
    'ticket.history_tab':    'Histórico',
    'ticket.not_found':      'Ticket não encontrado',
    'ticket.add_files':      'Ficheiros anexados',
    'ticket.event_desc':     'Descrição',
    'ticket.schedule_title': 'Agendar evento',
    'ticket.forward_title':  'Encaminhar ticket',
    'ticket.level_title':    'Mudar nível',
    'ticket.info_card':      'Informação',
    'ticket.sla_card':       'SLA',
    'ticket.sla_ok':         'Resolvido dentro do SLA',
    'ticket.sla_over':       '⚠ SLA ultrapassado',
    'ticket.write_comment':  'Escreve uma atualização para o utilizador...',
    'ticket.write_internal': 'Escreve uma nota interna...',


    // TicketDetail fields
    'ticket.agent_assigned':  'Agente atribuído',
    'ticket.reference':       'Referência',
    'ticket.created_at':      'Criado',
    'ticket.resolve_time':    'Tempo de resolução',
    'ticket.extra_info':      'Informação adicional',
    'ticket.email':           'Email',
    'ticket.escalated_to':    'Escalado para nível N',


    // FrontDesk formulario
    'fd.hero_title':       '¿Cómo podemos',
    'fd.hero_accent':      'ayudarte hoy?',
    'fd.hero_desc':        'Describe tu problema. Nuestro sistema lo analizará automáticamente con IA.',
    'fd.have_ticket':      '¿Ya tienes un ticket?',
    'fd.consult':          'Consultar',
    'fd.more_info':        'Más información',
    'fd.response_times':   'Tiempos de respuesta por prioridad',
    'fd.device_data':      'Datos del equipo',
    'fd.new_ticket_title': 'Nuevo ticket de soporte',
    'fd.your_data':        'Tus datos',
    'fd.full_name':        'Nombre completo',
    'fd.contact_email':    'Email de contacto',
    'fd.the_problem':      'El problema',
    'fd.title_field':      'Título',
    'fd.impact':           'Indica el impacto en tu trabajo',
    'fd.extra_info':       'Información adicional',
    'fd.problem_type':     'Tipo de problema',
    'fd.describe':         'Describe el problema, mensajes de error, desde cuándo ocurre…',
    'fd.attach':           'Adjuntar archivo · arrastra aquí · PNG, JPG, PDF, Word',
    'fd.clear':            'Limpiar',
    'fd.send':             'Enviar',
    'fd.required':         'Nombre y título son obligatorios.',
    'fd.estimate':         'Estimación beta · puede variar',
    'fd.impact1_label':    'No puedo trabajar en absoluto',
    'fd.impact1_desc':     'Equipo caído, sin red, cuenta bloqueada…',
    'fd.impact2_label':    'Trabajo muy limitado',
    'fd.impact2_desc':     'Periférico roto, email con fallos, sin carpetas compartidas…',
    'fd.impact3_label':    'Puedo trabajar con dificultad',
    'fd.impact3_desc':     'WiFi lento, aplicación secundaria con errores…',
    'fd.impact4_label':    'Es una molestia, puede esperar',
    'fd.impact4_desc':     'Instalación, alta de usuario, configuración…',


    // FrontDesk formulário
    'fd.hero_title':       'Como podemos',
    'fd.hero_accent':      'ajudar-te hoje?',
    'fd.hero_desc':        'Descreve o teu problema. O nosso sistema analisará automaticamente com IA.',
    'fd.have_ticket':      'Já tens um ticket?',
    'fd.consult':          'Consultar',
    'fd.more_info':        'Mais informação',
    'fd.response_times':   'Tempos de resposta por prioridade',
    'fd.device_data':      'Dados do equipamento',
    'fd.new_ticket_title': 'Novo ticket de suporte',
    'fd.your_data':        'Os teus dados',
    'fd.full_name':        'Nome completo',
    'fd.contact_email':    'Email de contacto',
    'fd.the_problem':      'O problema',
    'fd.title_field':      'Título',
    'fd.impact':           'Indica o impacto no teu trabalho',
    'fd.extra_info':       'Informação adicional',
    'fd.problem_type':     'Tipo de problema',
    'fd.describe':         'Descreve o problema, mensagens de erro, desde quando ocorre…',
    'fd.attach':           'Anexar ficheiro · arrasta aqui · PNG, JPG, PDF, Word',
    'fd.clear':            'Limpar',
    'fd.send':             'Enviar',
    'fd.required':         'Nome e título são obrigatórios.',
    'fd.estimate':         'Estimativa beta · pode variar',
    'fd.impact1_label':    'Não consigo trabalhar de todo',
    'fd.impact1_desc':     'Equipamento caído, sem rede, conta bloqueada…',
    'fd.impact2_label':    'Trabalho muito limitado',
    'fd.impact2_desc':     'Periférico avariado, email com falhas, sem pastas partilhadas…',
    'fd.impact3_label':    'Consigo trabalhar com dificuldade',
    'fd.impact3_desc':     'WiFi lento, aplicação secundária com erros…',
    'fd.impact4_label':    'É um incómodo, pode esperar',
    'fd.impact4_desc':     'Instalação, criação de utilizador, configuração…',


    'general.language':      'Idioma',
    'general.user_portal':   'Portal do utilizador',
    'general.public_dir':    'Diretório público',
    'general.room_booking':  'Reserva de espaços',
    'general.logout':        'Terminar sessão',


    'ticketlist.title':       'Todos os tickets',
    'ticketlist.search':      'Pesquisar ref, título, solicitante…',
    'ticketlist.filter_status': 'Estado',
    'ticketlist.filter_prio': 'Prioridade',
    'ticketlist.filter_level':'Nível',
    'ticketlist.col_ref':     'Ref',
    'ticketlist.col_title':   'Título',
    'ticketlist.col_status':  'Estado',
    'ticketlist.col_prio':    'Prioridade',
    'ticketlist.col_level':   'Nível',
    'ticketlist.col_agent':   'Agente',
    'ticketlist.col_sla':     'SLA',
    'ticketlist.col_updated': 'Atualizado',
    'ticketlist.unassigned':  'Por atribuir',
    'ticketlist.take':        'Assumir',

    // FrontDesk
    'fd.new_ticket':     'Novo ticket',
    'fd.track_ticket':   'Seguir ticket',
    'fd.title':          'Suporte Técnico',
    'fd.subtitle':       'Estamos aqui para te ajudar',
    'fd.ticket_ref':     'Referência do ticket',
    'fd.search':         'Escreve a tua questão...',
    // TrackTicket
    'track.title':               'Estado do Ticket',
    'track.forwarded_status':    'Fechado',
    'track.forwarded_desc':      'O seu pedido foi redirecionado para o departamento correspondente',
    'track.in_process':          'Em processo',
    'track.prio_low':            'Baixa',
    'track.prio_medium':         'Média',
    'track.prio_high':           'Alta',
    'track.prio_critical':       'Crítica',
    'track.agent_assigned':      'Agente atribuído',
    'track.support_ti':          'Suporte TI',
    'track.pending_assign':      'Aguardando atribuição',
    'track.pending_assign_desc': 'Um agente irá analisar o seu ticket em breve',
    'track.what_next':           'O que acontece a seguir?',
    'track.step_reception':      'Receção',
    'track.step_reception_desc': 'A IA classificou o seu ticket.',
    'track.step_assign':         'Atribuição',
    'track.step_assign_desc':    'Atribuído ao agente adequado.',
    'track.step_resolution':     'Resolução',
    'track.step_resolution_desc':'Será mantido informado por email.',
    'track.step_close':          'Fecho',
    'track.step_close_desc':     'Confirmamos a solução consigo.',
    'track.info_title':          'Informação de acompanhamento',
    'track.field_title':         'Título',
    'track.field_requester':     'Solicitante',
    'track.field_email':         'Email',
    'track.field_level':         'Nível de suporte',
    'track.field_level_val':     'Nível',
    'track.field_created':       'Criado',
    'track.status_label':        'Estado do ticket',
    'track.step_open':           'Aberto',
    'track.step_open_desc':      'Ticket registado e classificado',
    'track.step_progress':       'Em progresso',
    'track.step_progress_desc':  'Um agente está a trabalhar nisso',
    'track.step_escalated':      'Escalado',
    'track.step_escalated_desc': 'Encaminhado para suporte especializado',
    'track.step_resolved':       'Resolvido',
    'track.step_resolved_desc':  'Problema resolvido',
    'track.description':         'Descrição',
    'track.updates_title':       'Atualizações da equipa TI',
    'track.no_updates':          'A equipa de suporte ainda não adicionou atualizações. Será notificado por email quando houver novidades.',
    'track.resolved_banner':     'Este ticket foi resolvido',
    'track.resolved_banner_sub': 'Se o problema persistir, pode abrir um novo ticket.',
    'track.reply_title':         'Adicionar resposta',
    'track.reply_placeholder':   'Escreva aqui a sua resposta ou informação adicional para a equipa de suporte…',
    'track.reply_hint':          'A sua resposta será visível para a equipa TI',
    'track.reply_sending':       'A enviar…',
    'track.reply_send':          'Enviar resposta',
    'track.reply_done':          '✓ Resposta enviada',
    'track.back':                'Voltar',
    'track.loading':             'A carregar…',
    'track.searching':           'À procura do seu ticket…',
    'track.not_found_title':     'Não encontrado',
    'track.open_new':            'Abrir novo ticket',
    'track.toast':               'Ticket enviado com sucesso — enviámos confirmação por email',
  },

  // ── English ────────────────────────────────────────────
  en: {
    'nav.dashboard':     'Dashboard',
    'nav.tickets':       'Tickets',
    'nav.calendar':      'Calendar',
    'nav.computers':     'Equipment',
    'nav.agents':        'Agents',
    'nav.sla':           'SLA',
    'nav.surveys':       'Surveys',
    'nav.clients':       'Clients',
    'nav.departments':   'Routing',
    'nav.extensions':    'Extensions',
    'nav.rooms':         'Bookings',
    'nav.reports':       'Reports',
    'nav.superadmin':    'SuperAdmin',
    'app.logout':        'Sign out',
    'app.profile':       'My profile',
    'app.whats_new':     "What's new",
    'app.notifications': 'Notifications',
    'dashboard.my_tickets':      'My active tickets',
    'dashboard.unassigned':      'Unassigned',
    'dashboard.escalated':       'Escalated',
    'dashboard.critical_active': 'Active critical',
    'dashboard.resolved_today':  'Resolved today',
    'dashboard.my_assigned':     'My assigned tickets',
    'dashboard.team_queue':      'Team queue',
    'dashboard.no_assigned':     'No tickets assigned to you 🎉',
    'dashboard.new_ticket':      '+ New ticket',
    'dashboard.search':          'Search by title, ref or user...',
    'ticket.new': 'New ticket', 'ticket.ref': 'Reference', 'ticket.title': 'Title',
    'ticket.status': 'Status', 'ticket.priority': 'Priority', 'ticket.agent': 'Agent',
    'ticket.client': 'Requester', 'ticket.created': 'Created', 'ticket.updated': 'Updated',
    'ticket.all': 'All', 'ticket.critical': 'Critical', 'ticket.high': 'High',
    'ticket.medium': 'Medium', 'ticket.low': 'Low', 'ticket.open': 'Open',
    'ticket.in_progress': 'In progress', 'ticket.resolved': 'Resolved',
    'ticket.closed': 'Closed', 'ticket.pending': 'Pending',
    'ticket.assign_me': 'Assign to me', 'ticket.escalate': 'Escalate',
    'ticket.resolve': 'Resolve', 'ticket.close': 'Close', 'ticket.reopen': 'Reopen',
    'ticket.add_comment': 'Add comment', 'ticket.internal_note': 'Internal note',
    'ticket.description': 'Description', 'ticket.attachments': 'Attachments',
    'ticket.history': 'History', 'ticket.save': 'Save', 'ticket.cancel': 'Cancel',
    'ticket.send': 'Send', 'ticket.category': 'Category', 'ticket.department': 'Department',
    'ticket.level': 'Level', 'ticket.sla': 'SLA',
    'status.open': 'Open', 'status.in_progress': 'In progress',
    'status.pending': 'Pending', 'status.resolved': 'Resolved', 'status.closed': 'Closed',
    'priority.critical': 'Critical', 'priority.high': 'High',
    'priority.medium': 'Medium', 'priority.low': 'Low',
    'agents.title': 'Agents', 'agents.new': 'New agent', 'agents.name': 'Name',
    'agents.email': 'Email', 'agents.role': 'Role', 'agents.level': 'Level',
    'agents.status': 'Status', 'agents.active': 'Active', 'agents.inactive': 'Inactive',
    'agents.online': 'Online', 'agents.offline': 'Offline',
    'agents.admin': 'Administrator', 'agents.agent': 'Agent', 'agents.superadmin': 'SuperAdmin',
    'general.save': 'Save', 'general.cancel': 'Cancel', 'general.delete': 'Delete',
    'general.edit': 'Edit', 'general.create': 'Create', 'general.close': 'Close',
    'general.search': 'Search', 'general.filter': 'Filter', 'general.loading': 'Loading…',
    'general.yes': 'Yes', 'general.no': 'No', 'general.confirm': 'Confirm',
    'general.back': 'Back', 'general.next': 'Next', 'general.today': 'Today',
    'general.name': 'Name', 'general.email': 'Email', 'general.date': 'Date',
    'general.actions': 'Actions', 'general.results': 'results', 'general.of': 'of',
    'general.and': 'and', 'general.or': 'or', 'general.empty': 'No results',
    'login.title': 'Sign in with your institutional account',
    'login.google': 'Sign in with Google',
    'login.username': 'Username', 'login.password': 'Password',
    'login.submit': 'Sign in', 'login.error': 'Invalid username or password',
    'login.error_domain': 'Institutional accounts only',

    'general.language':      'Language',
    'general.user_portal':   'User portal',
    'general.public_dir':    'Public directory',
    'general.room_booking':  'Room booking',
    'general.logout':        'Sign out',


    'ticketlist.title':       'All tickets',
    'ticketlist.search':      'Search ref, title, requester…',
    'ticketlist.filter_status': 'Status',
    'ticketlist.filter_prio': 'Priority',
    'ticketlist.filter_level':'Level',
    'ticketlist.col_ref':     'Ref',
    'ticketlist.col_title':   'Title',
    'ticketlist.col_status':  'Status',
    'ticketlist.col_prio':    'Priority',
    'ticketlist.col_level':   'Level',
    'ticketlist.col_agent':   'Agent',
    'ticketlist.col_sla':     'SLA',
    'ticketlist.col_updated': 'Updated',
    'ticketlist.unassigned':  'Unassigned',
    'ticketlist.take':        'Take',

    'fd.new_ticket': 'New ticket', 'fd.track_ticket': 'Track ticket',
    'fd.title': 'Technical Support', 'fd.subtitle': "We're here to help you",
    'fd.ticket_ref': 'Ticket reference', 'fd.search': 'Type your query...',
    'track.title':'Ticket Status','track.forwarded_status':'Closed','track.forwarded_desc':'Your request has been redirected to the appropriate department',
    'track.in_process':'In process','track.prio_low':'Low','track.prio_medium':'Medium','track.prio_high':'High','track.prio_critical':'Critical',
    'track.agent_assigned':'Assigned agent','track.support_ti':'IT Support','track.pending_assign':'Pending assignment','track.pending_assign_desc':'An agent will review your ticket shortly',
    'track.what_next':'What happens next?','track.step_reception':'Reception','track.step_reception_desc':'AI has classified your ticket.',
    'track.step_assign':'Assignment','track.step_assign_desc':'Assigned to the right agent.','track.step_resolution':'Resolution','track.step_resolution_desc':'You will be kept informed by email.',
    'track.step_close':'Close','track.step_close_desc':'We confirm the solution with you.',
    'track.info_title':'Tracking information','track.field_title':'Title','track.field_requester':'Requester','track.field_email':'Email',
    'track.field_level':'Support level','track.field_level_val':'Level','track.field_created':'Created','track.status_label':'Ticket status',
    'track.step_open':'Open','track.step_open_desc':'Ticket registered and classified','track.step_progress':'In progress','track.step_progress_desc':'An agent is working on it',
    'track.step_escalated':'Escalated','track.step_escalated_desc':'Referred to specialized support','track.step_resolved':'Resolved','track.step_resolved_desc':'Problem solved',
    'track.description':'Description','track.updates_title':'IT team updates','track.no_updates':'The support team has not added any updates yet. You will be notified by email when there are news.',
    'track.resolved_banner':'This ticket has been resolved','track.resolved_banner_sub':'If the problem persists, you can open a new ticket.',
    'track.reply_title':'Add reply','track.reply_placeholder':'Write your reply or additional information for the support team…',
    'track.reply_hint':'Your reply will be visible to the IT team','track.reply_sending':'Sending…','track.reply_send':'Send reply','track.reply_done':'✓ Reply sent',
    'track.back':'Back','track.loading':'Loading…','track.searching':'Searching your ticket…','track.not_found_title':'Not found','track.open_new':'Open new ticket',
    'track.toast':'Ticket submitted successfully — we sent you a confirmation email',
  },
};

export default translations;

export function t(key, lang = 'es') {
  const dict = translations[lang] || translations.es;
  return dict[key] || translations.es[key] || key;
}

// This file is auto-extended — do not remove the closing export
